import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useMediaQuery } from "_common/component/MediaQueryProvider";
import MobileKYC from "./MobileKYC";
import DesktopKYC from "./DesktopKYC";

const VerifyKYCPage = observer(() => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  if (isMobile) return <MobileKYC />;

  return <DesktopKYC />;
});

export default VerifyKYCPage;
